import UniformHorizontalDivider from "./horizontal-divider";

export default UniformHorizontalDivider;
